import { createInstance } from 'i18next';

import deDE from '@klaviyo-mkt/i18n/translations/de-DE.json';
import enAU from '@klaviyo-mkt/i18n/translations/en-AU.json';
import enGB from '@klaviyo-mkt/i18n/translations/en-GB.json';
import enSG from '@klaviyo-mkt/i18n/translations/en-SG.json';
import enUS from '@klaviyo-mkt/i18n/translations/en-US.json';
import esES from '@klaviyo-mkt/i18n/translations/es-ES.json';
import esMX from '@klaviyo-mkt/i18n/translations/es-MX.json';
import frFR from '@klaviyo-mkt/i18n/translations/fr-FR.json';
import itIT from '@klaviyo-mkt/i18n/translations/it-IT.json';
import koKR from '@klaviyo-mkt/i18n/translations/ko-KR.json';
import nlNL from '@klaviyo-mkt/i18n/translations/nl-NL.json';
import plPL from '@klaviyo-mkt/i18n/translations/pl-PL.json';
import ptBR from '@klaviyo-mkt/i18n/translations/pt-BR.json';
import svSE from '@klaviyo-mkt/i18n/translations/sv-SE.json';
// TRANSLATION_IMPORTS

const initI18n = (langCode: string) => {
  const i18n = createInstance();

  i18n.init({
    resources: {
      'de-DE': {
        translation: deDE,
      },
      'en-AU': {
        translation: enAU,
      },
      'en-GB': {
        translation: enGB,
      },
      'en-SG': {
        translation: enSG,
      },
      'en-US': {
        translation: enUS,
      },
      'es-ES': {
        translation: esES,
      },
      'es-MX': {
        translation: esMX,
      },
      'fr-FR': {
        translation: frFR,
      },
      'it-IT': {
        translation: itIT,
      },
      'ko-KR': {
        translation: koKR,
      },
      'nl-NL': {
        translation: nlNL,
      },
      'pl-PL': {
        translation: plPL,
      },
      'pt-BR': {
        translation: ptBR,
      },
      'sv-SE': {
        translation: svSE,
      },
      // TRANSLATION_RESOURCES
    },
    contextSeparator: '__',
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en-US',
    keySeparator: false,
    lng: langCode,
    pluralSeparator: '__',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    react: {
      useSuspense: false,
    },
  });

  return i18n;
};

export default initI18n;
